<template>
  <div class="ml-3 ml-md-5 ml-sm-2 mr-4 pb-3 mb-4 header-bg">
    <div class="row mt-3 ">
      <div class="col col-sm col-12 pt-2  ">
        <em class="fas fa-clock text-orange  ml-2 mr-1" />
        <span class="font-16 font-weight-bold">
          Historial de Estatus
        </span>
      </div>
    </div>
    <custom-result-not-found v-if="items.length === 0" />
    <time-line class="mt-4 px-4 header-bg">
      <div v-for="(item, index) in items" :key="`item-index-${index}`">
        <time-line-item
          icon="fas fa-file d-flex justify-content-center align-items-center"
        >
          <template #date>
            <label class="history-date-title d-flex justify-content-end">
              Fecha
            </label>
            <label class="history-date-value">
              {{ $formatDate(item.createDate) }}
              {{ $formatDate(item.createDate, $templateDate.hour) }}
            </label>
          </template>
          <div class="mx-auto row px-4 mb-2">
            <div class="col-11 mx-auto row p-0">
              <div class="col-3">
                <label class="info-field-title">Estatus:</label>
                <label class="info-field-value">
                  <span
                    class="dot mr-2"
                    :class="getStatusColor(item.statusId)"
                  />

                  {{ item.statusName | empty }}
                </label>
              </div>
              <div class="col-3">
                <label class="info-field-title">Nombre del Usuario:</label>
                <label class="info-field-value">
                  {{ item.createUserName | empty }}
                </label>
              </div>
              <div
                v-if="item.documentId && !hasLocationDocuments(item)"
                class="col-3"
              >
                <label class="info-field-title">Nombre del Archivo:</label>
                <label class="info-field-value">
                  {{ item.filename | empty }}
                </label>
              </div>

              <div v-if="isConditional(item.statusId)" class="col">
                <label class="info-field-title">Fecha de Término:</label>
                <label class="info-field-value">
                  {{ item.statusEndDate | date }}
                </label>
              </div>
              <div v-if="item.determinationReasonDescription" class="col">
                <label class="info-field-title">Razón:</label>
                <label class="info-field-value">
                  {{ item.determinationReasonDescription | empty }}
                </label>
              </div>
            </div>
          </div>
          <div
            v-if="hasLocationDocuments(item)"
            class="col-11 mx-auto px-4 mb-2"
          >
            <div
              v-for="location in locationsWithDocuments(item)"
              :key="`location-document-${index}-${location.locationId}`"
              class="p-3 my-2 rounded row align-items-center bg-secondary-3"
            >
              <div class="col-4">
                <label class="info-field-title">Dirección Física:</label>
                <label class="info-field-value text-truncate">
                  {{ location.address | empty }}
                </label>
              </div>
              <div class="col-4">
                <div
                  v-if="location.permissionUniqueFileId"
                  class="d-flex align-items-center"
                >
                  <div class="mr-2 text-truncate">
                    <label class="info-field-title">Permiso Único:</label>
                    <label class="info-field-value text-truncate">
                      {{ location.permissionUniqueFileName | empty }}
                    </label>
                  </div>
                  <action-button
                    class="button-action"
                    i="fas fa-file-download"
                    variant="success"
                    @click="
                      () => onDownloadFile(location.permissionUniqueFileId)
                    "
                  />
                </div>
              </div>
              <div
                v-if="location.photosFileId"
                class="col-4 d-flex align-items-center"
              >
                <div class="mr-2 text-truncate">
                  <label class="info-field-title">
                    Fotos Interior y Exterior:
                  </label>
                  <label class="info-field-value text-truncate">
                    {{ location.photosFileName | empty }}
                  </label>
                </div>
                <action-button
                  class="button-action"
                  i="fas fa-file-download"
                  variant="success"
                  @click="() => onDownloadFile(location.photosFileId)"
                />
              </div>
            </div>
          </div>
          <div
            v-if="viewComments(item.comments)"
            class="comment-wrapper pl-3 bg-white mx-auto row"
          >
            <div class="col-12 py-2 pl-3">
              <i class="fas fa-info-circle text-orange pl-2 mr-2" />
              <span class="font-16 color-gray-7">
                Comentario:
              </span>
            </div>
            <div class="col-12 comment-box pl-5 mb-2">
              <label class="info-field-value">
                {{ item.comments | empty }}
              </label>
            </div>
          </div>
          <!-- <div class="row py-4 mx-3">
           <div class="col-md-2 col-sm-12">
             <custom-balloon
               :background-color="` bg-${getColorStatus(item.statusId)}`"
               :text="item.statusName"
             />
             <hr class="mt-5" />
           </div>
           <div class="col-md-10">
             <div class="row">
               <div class="col ml-5 ml-md-5 ml-sm-0">
                 <div class="color-gray-6 font-14 font-weight-normal">
                   Usuario:
                 </div>
                 <div
                   class="color-black font-16 font-weight-normal label-value"
                 >
                   {{ item.createUserName }}
                 </div>
               </div>
               <div
                 v-if="isConditional(item.statusId)"
                 class="col ml-3 ml-md-5 ml-sm-0"
               >
                 <div class="color-gray-6 font-14 font-weight-normal">
                   Fecha de Término:
                 </div>
                 <div
                   class="color-black font-16 font-weight-normal label-value"
                 >
                   {{ item.statusEndDate | date }}
                 </div>
               </div>
               <div
                 v-if="item.determinationReasonDescription"
                 class="col ml-5 ml-md-5 ml-sm-0 mt-3 mt-md-0"
               >
                 <div class="color-gray-6 font-14 font-weight-normal">
                   Razón:
                 </div>
                 <div
                   class="color-black font-16 font-weight-normal label-value"
                 >
                   {{ item.determinationReasonDescription | empty }}
                 </div>
               </div>
             </div>
             <div
               v-if="viewComments(item.comments)"
               class="row bg-white rounded p-2 mt-3 ml-5 ml-md-5 ml-sm-0"
             >
               <div class="col">
                 <div class="color-gray-6 font-14 font-weight-normal">
                   Comentario:
                 </div>
                 <div
                   class="color-black font-16 font-weight-normal label-value"
                 >
                   {{ item.comments }}
                 </div>
               </div>
             </div>
             <div
               v-if="item.deniedComment != null"
               class="row bg-white rounded p-2 mt-3 ml-5 ml-md-5 ml-sm-0"
             >
               <div class="col">
                 <div class="color-gray-6 font-14 font-weight-normal">
                   Comentario Contrato Denegado a Sometido:
                 </div>
                 <div
                   class="color-black font-16 font-weight-normal label-value"
                 >
                   {{ item.deniedComment }}
                 </div>
               </div>
             </div>
           </div>
         </div> -->
        </time-line-item>
      </div>
    </time-line>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import providerContractDocumentStatus, {
  providerContractDocumentStatusColor,
} from '@/utils/constants/providerContractDocumentStatus.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';

export default {
  name: 'ProfileSectionHistory',
  mixins: [alertMixin],
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getStatusColor() {
      return (statusId) => {
        switch (statusId) {
          case providerContractDocumentStatus.Pending:
            return 'bg-secondary-44';
          case providerContractDocumentStatus.Submitted:
            return 'bg-yellow';
          case providerContractDocumentStatus.Approved:
            return 'bg-green-light';
          case providerContractDocumentStatus.Denied:
            return 'bg-brown';
          case providerContractDocumentStatus.ConditionalApproved:
            return 'bg-orange-light';
          case providerContractDocumentStatus.ReplacementRequest:
            return 'bg-violet';
          default:
            return 'bg-white';
        }
      };
    },
    getColorStatus() {
      return (statusId) => {
        const hashMap = {
          [providerContractDocumentStatus.Pending]:
            providerContractDocumentStatusColor[
              providerContractDocumentStatus.Pending
            ],
          [providerContractDocumentStatus.Submitted]:
            providerContractDocumentStatusColor[
              providerContractDocumentStatus.Submitted
            ],
          [providerContractDocumentStatus.Approved]:
            providerContractDocumentStatusColor[
              providerContractDocumentStatus.Approved
            ],
          [providerContractDocumentStatus.Denied]:
            providerContractDocumentStatusColor[
              providerContractDocumentStatus.Denied
            ],
          [providerContractDocumentStatus.ConditionalApproved]:
            providerContractDocumentStatusColor[
              providerContractDocumentStatus.ConditionalApproved
            ],
          [providerContractDocumentStatus.ReplacementRequest]:
            providerContractDocumentStatusColor[
              providerContractDocumentStatus.ReplacementRequest
            ],
        };
        return hashMap[statusId];
      };
    },
    viewComments() {
      return (comments) => (!comments ? false : true);
    },
    locationsWithDocuments() {
      return (item) =>
        (item.locationDocuments || []).filter(
          (location) => location.permissionUniqueFileId || location.photosFileId
        );
    },
    hasLocationDocuments() {
      return (item) => this.locationsWithDocuments(item).length > 0;
    },
    isConditional() {
      return (statusId) => {
        return statusId === providerContractDocumentStatus.ConditionalApproved;
      };
    },
  },
  data() {
    return {
      // Add any local state or computed properties if needed
    };
  },
  mounted() {
    this.$emit('load');
  },
  methods: {
    onDownloadFile(id) {
      _downloadDocumentByAttachmentId(id).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.dot {
  height: 14px;
  width: 14px;
  border-radius: 50%;
  display: inline-block;
}
.history-date-title {
  text-align: right;
  margin-bottom: 0px;
  font: 0.75rem Lato;
  letter-spacing: 0px;
  color: map-get($colors, 'secondary-6');
}
.history-date-value {
  font: Bold 1rem Lato;
  text-align: right;
  letter-spacing: 0px;
  color: map-get($colors, 'black');
}
.info-field-title {
  font: 0.875rem Lato;
  letter-spacing: 0px;
  margin: 0;
  color: map-get($colors, 'secondary-6');
}
.info-field-value {
  font: 1rem Lato;
  letter-spacing: 0px;
  color: map-get($colors, 'black');
  display: block;
}
::v-deep .dot {
  box-shadow: none !important;
  margin-right: 4px !important;
}
.button-action {
  width: 35px;
  height: 35px;
}
::v-deep .timeline__content--inner {
  padding: 0.5rem !important;
}
.header-bg {
  background-color: #ffff;
}
</style>
